import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  Stack,
  Box,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useStyles } from "./styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { shadow } from "../../../../assets/const";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import PersonIcon from "@mui/icons-material/Person";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { color } from "../../../../assets/const/color";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { ErrorMessage, Formik } from "formik";
import useStudent from "../../../../Hooks/student";
import moment from "moment";
import EducationInformation, {
  educationInformationSchema,
} from "./EducationInformation";
import ParentalInfo, { parentalInfoSchema } from "./ParentalInfo";
import AchievementInfo, { achievementSchema } from "./AchievementInfo";
import ExtraCurricular, { extraCurricularSchema } from "./ExtraCurricular";
import OtherInterests from "./OtherInterests";
import * as Yup from "yup";
import deaultIMG from "../../../../assets/images/Dashboard/avatar.png";
// import { srcollIntoStudent } from "../../../../Utils/scrollToView";
import useCourse from "../../../../Hooks/course";
import { toast } from "react-toastify";
import logout from "../../../../assets/images/Sidebar/logout.svg";
import useAuthStore from "../../../../Hooks/auth";
import { yearList } from "../../../StaffScreen/Migration/fillter";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CheckBox } from "@mui/icons-material";
import { current } from "@reduxjs/toolkit";

const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#D1FADF",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "green",
  },
}));

const phoneRegExp = /^[0]?[0-9]\d{11,13}$/;

const studentPersonalValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("* Please enter first name"),
  lastName: Yup.string().required("* Please enter last name"),
  joiningDate: Yup.date()
    .max(new Date(), "* Please select the valid joining date")
    .required("* Please select joining date"),
  email: Yup.string()
    .email("* Not valid email")
    .required("* Please enter email"),
  phone: Yup.string()
    .matches(phoneRegExp, {
      message: "* Phone number is not valid",
      excludeEmptyString: true,
    })
    .required("* Please enter mobile number"),
  idDepartment: Yup.string().required("* Please select department"),
  regNumber: Yup.string().required("* Please enter registration number"),
  dob: Yup.date()
    .max(new Date(), "* Please select the valid DOB")
    .required("* Please select the DOB"),
  batchYear: Yup.string().required("* Please enter batch").matches(/^(19[0-9]{2}|20[0-5][0-9])-(19[0-9]{2}|20[0-5][0-9])$/, 'Year format should be 2001-2005'),
  bloodGroup: Yup.string().required("* Please select blood group"),
  address: Yup.string().required("* Please enter address"),
  programId: Yup.string().required("* Please select program"),
  currentYear: Yup.string().required("* Please select current year"),
});

const AddEditStudent = () => {
  const { institutionId } = useAuthStore();
  const studentPersonal = {
    firstName: "",
    lastName: "",
    joiningDate: "",
    bloodGroup: "",
    batchYear: "",
    email: "",
    phone: "",
    address: "",
    idDepartment: "",
    dob: "",
    regNumber: "",
    programId: "",
    currentYear: "",
    institutionId,
  };

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState("panel1");
  const { layoutRef } = useOutletContext();
  const educationRef = useRef();
  const contactRef = useRef();
  const achievementRef = useRef();
  const extraCurricularRef = useRef();
  const studentModuleRef = useRef();
  const { checked, setChecked } = useState(false);

  const {
    addStudentPersonalInfo,
    addEducationAction,
    educationInformation,
    studentPersonalInfo,
    studentEducationAction,
    studentParentalInfo,
    addParentalInfoAction,
    addStudentContactsAction,
    addAchievementAction,
    achievementsList,
    addAchievementsAction,
    extraCurricularActivityList,
    addExtraCurricularActivityAction,
    addExtraCurricularActivitiesAction,
    updateStudentProfileAction,
    uploadProfilePicAction,
    setProfileCompletenessAction,
    profileCompleteness,
    getStudentInfoAction,
    addInterestListAction,
    interestList,
    studentData,
    getProgramAction,
    program = [],
  } = useStudent();

  const { departmentData } = useCourse();
  const [edit, setEdit] = React.useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const formikRef = useRef();

  React.useEffect(() => {
    if (location.pathname === "/studentManagement/edit") {
      getStudentInfoAction({
        idStudent: location.state && location.state.idStudent,
      });
      setEdit(true);
    } else {
      setEdit(false);
    }
  }, [location]);

  // const onScroll = (e) => {
  //   console.log("onScoll", layoutRef.current.scrollTop);
  // };
  React.useEffect(() => {
    getProgramAction({
      course: {
        limit: 10,
        offSet: 0,
        institutionId,
      },
    });

    // layoutRef.current.addEventListener("scroll", onScroll);
    // return () => {
    //   layoutRef?.current?.removeEventListener("scroll", onScroll);
    // };
  }, []);

  React.useEffect(() => {
    if (formikRef.current) {
      const { setFieldValue } = formikRef.current;
      if (edit) {
        setFieldValue("bloodGroup", studentPersonalInfo?.bloodGroup || "");
        setFieldValue("firstName", studentPersonalInfo?.firstName || "");
        setFieldValue("lastName", studentPersonalInfo?.lastName || "");
        setFieldValue("batchYear", studentPersonalInfo?.batchYear || "");
        setFieldValue("email", studentPersonalInfo?.email || "");
        setFieldValue("phone", studentPersonalInfo?.phone || "");
        setFieldValue("address", studentPersonalInfo?.address || "");
        setFieldValue("idDepartment", studentPersonalInfo?.idDepartment || "");
        setFieldValue("dob", studentPersonalInfo?.dob || "");
        setFieldValue("joiningDate", studentPersonalInfo?.joiningDate || "");
        setFieldValue("regNumber", studentPersonalInfo?.regNumber || "");
        setFieldValue("id", studentPersonalInfo?.id || "");
        setFieldValue("programId", studentPersonalInfo?.programId || "");
        setFieldValue("currentYear", studentPersonalInfo?.currentYear || "");
      }
      if (location?.state?.idDepartment) {
        setFieldValue("idDepartment", location?.state?.idDepartment || "");
      }
    }
  }, [edit, studentPersonalInfo]);

  const handleExpand = (panel) => (event, isExpanded) => {
    if (expanded === panel) {
      setExpanded("");
      layoutRef.current.scrollTo(0, event.screenY - event.clientY);
    } else {
      if (panel !== 'panel1' && studentPersonalInfo?.id) {
        setExpanded(panel);
        const ids = Number(panel.replace("panel", ""));
        setTimeout(() => {
          var element = document.getElementById(`ac_${ids}`);
          var offsetTop = element.offsetTop - 80;
          layoutRef.current.scrollTop = offsetTop;
        }, 500);
        // layoutRef.current.scroll({
        //   left: 0,
        //   top: event.screenY + event.target.clientHeight + 60 - event.clientY,
        // });
      }
      else if (panel === 'panel1') {
        setExpanded(panel);
        const ids = Number(panel.replace("panel", ""));
        setTimeout(() => {
          var element = document.getElementById(`ac_${ids}`);
          var offsetTop = element.offsetTop - 80;
          layoutRef.current.scrollTop = offsetTop;
        }, 500);
      }
      else {
        toast.warning('Please Fill In The Student\'s Personal Information First!', {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  };

  React.useEffect(() => {
    // document.getElementById("studentPersonal")?.scroll(0, 0);
    // srcollIntoStudent(`#studentPersonal`);
  }, []);

  const handleProfile = (e) => {
    if (studentPersonalInfo?.id) {
      // get the files
      let file = e.target.files[0];

      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        uploadProfilePicAction({
          uploadProfilePic: {
            idStudent: studentPersonalInfo.id,
            fileName: e.timeStamp,
            profilePicString: reader.result.substr(
              reader.result.indexOf(",") + 1
            ),
          },
        });
      };
    }
  };
  const warningMsg = () => {
    toast.warning('Please Fill In The Student\'s Personal Information First!', {
      position: toast.POSITION.TOP_RIGHT
    });
  }
  const handleSubmitForm = (event) => {
    event.stopPropagation();
  };

  const handleClick = (event) => {
    if (event.target.checked) {
    } else {
    }
    setChecked((current) => !current);
  };

  return (
    <>
     
      
      <Grid
        container
        spacing={3}
        className={classes.addStaff_main}
        ref={studentModuleRef}
      >
        <Grid item xl={9} md={12} sm={12}>
          <Stack sx={{ px: 2, flexDirection: "row", justifyContent: "right" }}>
            {/* <Typography
              sx={{
                pr: 2,
                mb: 2,
                // display: status ? "none" : "block",
                transition: "width 0.3s",
                color: "red",
              }}
            >
              Please fill parental email for parents login
            </Typography> */}
            <Typography
              sx={{
                pr: 2,
                mb: 2,
                // display: status ? "none" : "block",
                transition: "width 0.3s",
              }}
            >
              Back
            </Typography>
            <Stack
              sx={{ cursor: "pointer" }}
              role={"button"}
              onClick={() => navigate(-1)}
            >
              <img src={logout} alt="logout" />
            </Stack>
          </Stack>
          {edit && (
            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                mb: 2,
                background: color.white,
                filter: shadow,
                borderRadius: "23px",
              }}
            >
              <Stack sx={{ flexDirection: "row" }}>
                <Typography sx={{ fontWeight: 700, color: color.darkGreen }}>
                  Profile Completeness
                </Typography>
              </Stack>
              <Stack
                sx={{ flexDirection: "row", alignItems: "center", gap: 2 }}
              >
                <Typography sx={{ fontWeight: 700, color: color.darkGreen }}>
                  Registration Number
                </Typography>{" "}
                <Typography sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>
                  {studentPersonalInfo?.regNumber}
                </Typography>
                {/* <Button
                  type="button"
                  sx={{ px: 2, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                >
                  Update
                </Button> */}
              </Stack>
            </Stack>
          )}

          {/* Student Personal Information */}
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleExpand("panel1")}
            id="ac_1"
            // onClick={() => {
            //   srcollIntoStudent("ac_1");
            // }}
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
              px: 2,
              "& .MuiAccordionDetails-root": {
                padding: 0,
              },
            }}
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={
                expanded === "panel1" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography className={classes.heading}>
                Student Personal Information
              </Typography>

              <>
                {/* <Typography className={classes.secondaryHeading}>
                  Student ID
                </Typography> */}

                <Stack sx={{ mr: 2 }}>
                  <Button
                    type="submit"
                    form="studentPersonal"
                    sx={{ px: 1, py: 1, borderRadius: "50px" }}
                    className={classes.add_btn}
                    onClick={handleSubmitForm}
                  >
                    {!edit ? "Save" : "Update"}
                  </Button>
                </Stack>
              </>

              <Stack sx={{ color: "#25D5A1" }}>
                <Stack minWidth={"24px"} />
              </Stack>
            </AccordionSummary>
            <Formik
              initialValues={studentPersonal}
              validationSchema={studentPersonalValidationSchema}
              validateOnBlur={false}
              validateOnChange={false}
              enableReinitialize
              innerRef={formikRef}
              onSubmit={(values) => {
                console.log(values, "354678");
                if (!edit) {
                  addStudentPersonalInfo({
                    studentPersonalInfo: {
                      ...values,
                      // joiningDate: moment(values.joiningDate).format(
                      //   "DD-MM-YYYY"
                      // ),
                      // regNumber: parseInt(Math.random() * 100000) + "",
                      // joiningDate: "03-01-2020",
                      // currentYear: "2020",
                      // currentSemester: "1",
                      phone: `${values.phone}`,
                      groupId: "",
                    },
                  });
                } else {
                  updateStudentProfileAction({
                    studentPersonalInfo: {
                      ...values,
                      // currentYear: "2020",
                      // currentSemester: "1",
                      phone: `${values.phone}`,
                      groupId: "",
                    },
                  });
                }
              }}
            >
              {(formik) => {
                const {
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  values,
                  setFieldValue,
                } = formik;
                return (
                  <>
                    <form id="studentPersonal" onSubmit={handleSubmit}>
                      <AccordionDetails>
                        <Grid
                          container
                          columnSpacing={4}
                          rowSpacing={2}
                          sx={{ paddingBottom: "10px" }}
                        >
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              <Typography className={classes.label}>
                                First Name
                              </Typography>
                              <div>
                                <TextField
                                  id="firstName"
                                  name="firstName"
                                  placeholder="Enter First Name"
                                  sx={{
                                    width: "230px",
                                    display: "flex",
                                  }}
                                  className={
                                    errors.firstName && touched.firstName
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  onChange={handleChange}
                                  value={values.firstName}
                                />
                                <ErrorMessage
                                  name="firstName"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                // gap: 2,
                                // mb: 2,
                                width: "100%",
                              }}
                            >
                              <Stack>
                                <Typography className={classes.label}>
                                  Department
                                </Typography>
                              </Stack>
                              <Stack>
                                <Select
                                  id="idDepartment"
                                  name="idDepartment"
                                  value={values.idDepartment}
                                  displayEmpty
                                  onChange={handleChange}
                                  IconComponent={CustomExpandMore}
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                  }}
                                  className={
                                    errors.idDepartment && touched.idDepartment
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select Department
                                  </MenuItem>
                                  {departmentData &&
                                    departmentData?.map((val, ind) => {
                                      return (
                                        <MenuItem
                                          key={ind}
                                          selected
                                          value={val.id}
                                        >
                                          {val.name}
                                        </MenuItem>
                                      );
                                    })}
                                </Select>
                                <ErrorMessage
                                  name="idDepartment"
                                  component="span"
                                  className={classes.error}
                                />
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                              }}
                            >
                              <Typography className={classes.label}>
                                Last Name
                              </Typography>
                              <div>
                                <TextField
                                  id="lastName"
                                  name="lastName"
                                  placeholder="Enter Last Name"
                                  sx={{
                                    width: "230px",
                                    display: "flex",
                                  }}
                                  className={
                                    errors.lastName && touched.lastName
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  onChange={handleChange}
                                  value={values.lastName}
                                />
                                <ErrorMessage
                                  name="lastName"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              <Typography className={classes.label}>
                                Date of Joining
                              </Typography>
                              <div>
                                <TextField
                                  id="joiningDate"
                                  type="date"
                                  name="joiningDate"
                                  sx={{
                                    width: "230px",
                                    display: "flex",
                                  }}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  className={
                                    errors.joiningDate && touched.joiningDate
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  placeholder="Enter Date of birth"
                                  onChange={handleChange}
                                  value={values && values.joiningDate}
                                />
                                <ErrorMessage
                                  name="joiningDate"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              <Typography className={classes.label}>
                                Blood Group
                              </Typography>
                              <div>
                                <Select
                                  id="bloodGroup"
                                  name="bloodGroup"
                                  placeholder="Blood Group"
                                  sx={{
                                    display: "flex",
                                    width: "230px",
                                  }}
                                  IconComponent={CustomExpandMore}
                                  className={
                                    errors.bloodGroup && touched.bloodGroup
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  onChange={handleChange}
                                  value={values.bloodGroup}
                                  displayEmpty
                                >
                                  <MenuItem value="" disabled>
                                    Select Blood Group
                                  </MenuItem>
                                  <MenuItem value="A+">A+</MenuItem>
                                  <MenuItem value="A-">A-</MenuItem>
                                  <MenuItem value="B+">B+</MenuItem>
                                  <MenuItem value="B-">B-</MenuItem>
                                  <MenuItem value="O+">O+</MenuItem>
                                  <MenuItem value="O-">O-</MenuItem>
                                  <MenuItem value="AB+">AB+</MenuItem>
                                  <MenuItem value="AB-">AB-</MenuItem>
                                  <MenuItem value="A1+-">A1+</MenuItem>
                                  <MenuItem value="A2+">A2+</MenuItem>
                                  <MenuItem value="A1B+">A1B+</MenuItem>
                                </Select>
                                <ErrorMessage
                                  name="bloodGroup"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              <Typography className={classes.label}>
                                Batch
                              </Typography>
                              <div style={{width:'230px'}}>
                                <TextField
                                  id="batchYear"
                                  name="batchYear"
                                  placeholder="Enter Year of Batch"
                                  sx={{
                                    width: "230px",
                                    display: "flex",
                                  }}
                                  className={
                                    errors.batchYear && touched.batchYear
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  onChange={handleChange}
                                  value={values.batchYear}
                                />
                                <ErrorMessage
                                  name="batchYear"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              <Typography className={classes.label}>
                                Email
                              </Typography>
                              <div>
                                <TextField
                                  id="email"
                                  name="email"
                                  placeholder="Enter Email"
                                  sx={{
                                    width: "230px",
                                    display: "flex",
                                  }}
                                  onChange={handleChange}
                                  value={values.email}
                                  className={
                                    errors.email && touched.email
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                />
                                <ErrorMessage
                                  name="email"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                              }}
                            >
                              <Typography className={classes.label}>
                                Mobile
                              </Typography>
                              <div>
                                <PhoneInput
                                  id="phone"
                                  name="phone"
                                  country={"in"}
                                  placeholder="Enter Mobile"
                                  sx={{
                                    width: "230px !important",
                                    display: "flex",
                                  }}
                                  onChange={(phone) =>
                                    setFieldValue("phone", phone)
                                  }
                                  value={values.phone}
                                  className={
                                    errors.phone && touched.phone
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                />
                                <ErrorMessage
                                  name="phone"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              {/* <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 4,
                                mb: 2,
                              }}
                            >
                              <Stack> */}
                              <Typography className={classes.label}>
                                Address
                              </Typography>
                              <div>
                                <TextField
                                  id="address"
                                  name="address"
                                  placeholder="Enter Address"
                                  sx={{
                                    width: "230px",
                                    display: "flex",
                                  }}
                                  onChange={handleChange}
                                  value={values.address}
                                  className={
                                    errors.address && touched.address
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                />
                                <ErrorMessage
                                  name="address"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                              }}
                            >
                              <Typography className={classes.label}>
                                Date of Birth
                              </Typography>
                              <div>
                                <TextField
                                  id="dob"
                                  type="date"
                                  name="dob"
                                  // max={new Date().toDateString()}
                                  sx={{
                                    width: "230px !important",
                                    display: "flex",
                                  }}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  className={
                                    errors.dob && touched.dob
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  placeholder="Enter DOB"
                                  onChange={handleChange}
                                  value={values && values.dob}
                                />
                                <ErrorMessage
                                  name="dob"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                width: "100%",
                              }}
                            >
                              <Typography className={classes.label}>
                                Reg Number
                              </Typography>
                              <div>
                                <TextField
                                  id="regNumber"
                                  name="regNumber"
                                  placeholder="Please Enter Reg Number"
                                  sx={{
                                    width: "230px",
                                    display: "flex",
                                  }}
                                  className={
                                    errors.regNumber && touched.regNumber
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values.regNumber}
                                  disabled={edit}
                                />
                                <ErrorMessage
                                  name="regNumber"
                                  component="span"
                                  className={classes.error}
                                />
                              </div>
                            </Box>
                          </Grid>

                          <Grid item md={6} sm={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                width: "100%",
                                mb: 2,
                              }}
                            >
                              <Stack>
                                <Typography className={classes.label}>
                                  Program
                                </Typography>
                              </Stack>
                              <Stack>
                                <Select
                                  id="programId"
                                  name="programId"
                                  value={values.programId}
                                  displayEmpty
                                  onChange={handleChange}
                                  IconComponent={CustomExpandMore}
                                  sx={{
                                    display: "flex",
                                    width: "230px",
                                  }}
                                  className={
                                    errors.programId && touched.programId
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select Program
                                  </MenuItem>
                                  {program &&
                                    program.length > 0 &&
                                    program.map((val, ind) => {
                                      return (
                                        <MenuItem key={ind} value={val.id}>
                                          {val.name}
                                        </MenuItem>
                                      );
                                    })}
                                </Select>
                                <ErrorMessage
                                  name="programId"
                                  component="span"
                                  className={classes.error}
                                />
                              </Stack>
                            </Box>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <Stack>
                                <Typography className={classes.label}>
                                  Current Year
                                </Typography>
                              </Stack>
                              <Stack>
                                <Select
                                  id="currentYear"
                                  name="currentYear"
                                  value={values.currentYear}
                                  displayEmpty
                                  onChange={handleChange}
                                  IconComponent={CustomExpandMore}
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                  }}
                                  className={
                                    errors.currentYear && touched.currentYear
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                >
                                  <MenuItem value="" disabled>
                                    Select Current Year
                                  </MenuItem>
                                    {yearList && yearList?.map((_el, index) => (
                                        <MenuItem value={_el.value} key={index}>
                                            {_el.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <ErrorMessage
                                  name="currentYear"
                                  component="span"
                                  className={classes.error}
                                />
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid item md={6} sm={12}>
                            {/* <Stack
                              sx={{
                                p: 2,
                                alignItems: "right",
                                flexDirection: "row",
                              }}
                            >
                              <CheckBox
                                // checked={selectedValue == _el.id}
                                // onChange={() => handleRadio(_el)}
                                value={checked}
                                onChange={handleClick}
                                style={{ color: "#25D5A1" }}
                              />
                              SMS Notification
                            </Stack> */}
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </form>
                  </>
                );
              }}
            </Formik>
          </Accordion>

          {/* Education Information */}
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleExpand("panel2")}
            // onClick={() => {
            //   srcollIntoStudent("ac_2");
            // }}
            id="ac_2"
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                gap: 4,
                mb: 2,
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
              px: 2,
            }}
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={
                expanded === "panel2" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              aria-controls="panel2bh-content"
              id="panel2bh-header"
            >
              <Typography className={classes.heading}>
                Education Information
              </Typography>

              <Stack sx={{ mr: 2 }}>
                <Button
                  // type="submit"
                  form="addStudentEducation"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={studentPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (educationRef.current) {
                      educationRef.current.handleSubmit();
                      setTimeout(() => {
                        if (educationRef.current.isValid) {
                          studentEducationAction({
                            educationList: educationInformation,
                          });
                        }
                      }, 200);
                    }
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>

              <Stack
                sx={{ color: "#25D5A1" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (studentPersonalInfo?.id) {
                    educationRef.current.submitForm();
                    educationInformationSchema
                      .isValid(educationRef?.current?.values)
                      .then((valid) => {
                        if (valid) {
                          addEducationAction();
                        }
                        throw new Error("Please fill previous");
                      })
                      .catch((e) => {
                        educationRef.current.validateForm();
                      });
                  }
                }}
              >
                <AddIcon />
              </Stack>
            </AccordionSummary>

            {educationInformation &&
              educationInformation.map((_el, index) => (
                <EducationInformation
                  educationRef={educationRef}
                  key={index}
                  studentModuleRef={studentModuleRef}
                  currentIndex={index}
                  id={`educationunique${index + 1}`}
                />
              ))}
          </Accordion>

          {/* Parental & Contact Information */}
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleExpand("panel3")}
            // onClick={() => {
            //   srcollIntoStudent("ac_3");
            // }}
            id="ac_3"
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
              px: 2,
            }}
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={
                expanded === "panel3" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              aria-controls="panel3bh-content"
              id="panel3bh-header"
            >
              <Typography className={classes.heading}>
                Parental & Contact Information
              </Typography>

              <Stack sx={{ mr: 2 }}>
                <Button
                  // type="submit"
                  form="studentParentalInfo"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={studentPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (contactRef.current) {
                      contactRef.current.handleSubmit();
                      setTimeout(() => {
                        if (contactRef.current.isValid) {
                          addStudentContactsAction({
                            studentContacts: studentParentalInfo,
                          });
                        }
                      }, 200);
                    }
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
              <Stack
                sx={{ color: "#25D5A1" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (studentPersonalInfo?.id) {
                    contactRef.current.submitForm();
                    parentalInfoSchema
                      .isValid(contactRef?.current?.values)
                      .then((valid) => {
                        if (valid) {
                          addParentalInfoAction();
                        }
                        throw new Error("Please fill previous");
                      })
                      .catch((e) => {
                        contactRef.current.validateForm();
                      });
                  }
                }}
              >
                <AddIcon />
              </Stack>
            </AccordionSummary>
            {studentParentalInfo &&
              studentParentalInfo.map((_el, index) => (
                <ParentalInfo
                  key={index}
                  currentIndex={index}
                  studentModuleRef={studentModuleRef}
                  contactRef={contactRef}
                  id={`contactInfoUnique${index + 1}`}
                />
              ))}
          </Accordion>

          {/* Sports Achievements */}
          <Accordion
            expanded={expanded === "panel4"}
            onChange={handleExpand("panel4")}
            // onClick={() => {
            //   srcollIntoStudent("ac_4");
            // }}
            id="ac_4"
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
              px: 2,
            }}
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={
                expanded === "panel4" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              aria-controls="panel4bh-content"
              id="panel4bh-header"
            >
              <Typography className={classes.heading}>
                Sports Achievements
              </Typography>

              <Stack sx={{ mr: 2 }}>
                <Button
                  form="achievementInfo"
                  // type="submit"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={studentPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (achievementRef.current) {
                      achievementRef.current.handleSubmit();
                      setTimeout(() => {
                        if (achievementRef.current.isValid) {
                          addAchievementsAction({
                            achievementsList: achievementsList,
                          });
                        }
                      }, 200);
                    }
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
              <Stack
                sx={{ color: "#25D5A1" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (studentPersonalInfo?.id) {
                    achievementRef.current.submitForm();
                    achievementSchema
                      .isValid(achievementRef?.current?.values)
                      .then((valid) => {
                        if (valid) {
                          addAchievementAction();
                        }
                        throw new Error("Please fill previous");
                      })
                      .catch((e) => {
                        achievementRef.current.validateForm();
                      });
                  }
                }}
              >
                <AddIcon />
              </Stack>
            </AccordionSummary>
            {achievementsList &&
              achievementsList.map((_el, index) => (
                <AchievementInfo
                  key={index}
                  studentModuleRef={studentModuleRef}
                  currentIndex={index}
                  achievementRef={achievementRef}
                />
              ))}
            {/* Student Personal Information */}
          </Accordion>

          {/* Extra curricular */}
          <Accordion
            expanded={expanded === "panel5"}
            onChange={handleExpand("panel5")}
            // onClick={() => {
            //   srcollIntoStudent("ac_5");
            // }}
            id="ac_5"
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
              px: 2,
            }}
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={
                expanded === "panel5" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              aria-controls="panel5bh-content"
              id="panel5bh-header"
            >
              <Typography className={classes.heading}>
                Extra Curricular
              </Typography>

              <Stack sx={{ mr: 2 }}>
                <Button
                  form="extraCurricular"
                  type="submit"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  disabled={studentPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (extraCurricularRef.current) {
                      extraCurricularRef.current.handleSubmit();
                      setTimeout(() => {
                        if (extraCurricularRef.current.isValid) {
                          addExtraCurricularActivitiesAction({
                            extraCurricularActivityList:
                              extraCurricularActivityList,
                          });
                        }
                      }, 200);
                    }
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
              <Stack
                sx={{ color: "#25D5A1" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (studentPersonalInfo?.id) {
                    extraCurricularRef.current.submitForm();
                    extraCurricularSchema
                      .isValid(extraCurricularRef?.current?.values)
                      .then((valid) => {
                        if (valid) {
                          addExtraCurricularActivityAction();
                        }
                        throw new Error("Please fill previous");
                      })
                      .catch((e) => {
                        extraCurricularRef.current.validateForm();
                      });
                  }
                }}
              >
                <AddIcon />
              </Stack>
            </AccordionSummary>
            {extraCurricularActivityList &&
              extraCurricularActivityList.map((_el, index) => (
                <ExtraCurricular
                  key={index}
                  studentModuleRef={studentModuleRef}
                  currentIndex={index}
                  id={`extraCurricularUnique${index + 1}`}
                  extraCurricularRef={extraCurricularRef}
                />
              ))}
          </Accordion>

          {/* Other Interests */}
          <Accordion
            expanded={expanded === "panel6"}
            onChange={handleExpand("panel6")}
            // onClick={() => {
            //   srcollIntoStudent("ac_6");
            // }}
            id="ac_6"
            sx={{
              mb: 3,
              borderRadius: "23px !important",
              "&.MuiAccordion-root:before": {
                backgroundColor: "white",
              },
              "&.MuiAccordion-root": {
                filter: shadow,
                boxShadow: "none",
              },
              px: 2,
            }}
          >
            <AccordionSummary
              sx={{ flexDirection: "row-reverse" }}
              expandIcon={
                expanded === "panel6" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )
              }
              aria-controls="panel6bh-content"
              id="panel6bh-header"
            >
              <Typography className={classes.heading}>
                Other interests
              </Typography>

              <Stack sx={{ mr: 2 }}>
                <Button
                  type="submit"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_btn}
                  form="otherInterests"
                  disabled={studentPersonalInfo?.id ? false : true}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  {!edit ? "Save" : "Update"}
                </Button>
              </Stack>
              <Stack sx={{ color: "#25D5A1" }}>
                <Stack minWidth={"24px"} />
              </Stack>
            </AccordionSummary>
            <OtherInterests studentModuleRef={studentModuleRef} />
          </Accordion>
        </Grid>
        <Grid item xl={3} md={12} sm={12}>
          <Stack
            className={classes.profile_card}
            sx={{ justifyContent: "space-evenly" }}
          >
            <Stack
              sx={{
                width: "80px",
                height: "80px",
                "& img": {
                  borderRadius: "50px",
                  width: "100%",
                  height: "100%",
                },
              }}
            >
              <img
                src={studentPersonalInfo?.pictureUrl || deaultIMG}
                alt="profile"
              />
            </Stack>
            <Stack
              sx={{
                textAlign: "center",
                py: 2,
              }}
            >
              {studentPersonalInfo?.firstName &&
                studentPersonalInfo?.lastName ? (
                <Typography sx={{ color: "black", fontWeight: "500" }}>
                  {studentPersonalInfo?.firstName +
                    " " +
                    studentPersonalInfo?.lastName}
                </Typography>
              ) : (
                <Typography sx={{ color: "black", fontWeight: "500" }}>
                  Student Name
                </Typography>
              )}
              <Stack sx={{ textAlign: "center", my: 1 }}>
                <Typography sx={{ color: "#8083A3" }}>
                  {studentPersonalInfo?.regNumber}
                </Typography>
              </Stack>

              <Button
                component="label"
                className={classes.upload_photo}
                variant="outlined"
                sx={{ marginRight: "1rem" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!studentPersonalInfo?.id) {
                    warningMsg();
                  }
                }}
              >
                Upload Photo
                {
                  (!studentPersonalInfo?.id) ? (<input type="file" hidden disabled />)
                    :
                    (<input type="file" hidden onChange={(e) => handleProfile(e)} />)

                }
              </Button>
            </Stack>
            <Stack
              sx={{
                width: "80%",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                background: "#F6FEF9",
                p: 2,
                borderRadius: "12px",
              }}
            >
              <Stack
                sx={{
                  color: "green",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50px",
                  background: "#D1FADF",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PersonIcon />
              </Stack>
              <Stack sx={{ width: "80%" }}>
                <Stack
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                  }}
                >
                  <Typography sx={{ color: "#054F31", fontWeight: 500 }}>
                    Profille Complete
                  </Typography>
                  <Typography sx={{ color: "#027A48" }}>
                    {profileCompleteness}%
                  </Typography>
                </Stack>
                <BorderLinearProgress
                  variant="determinate"
                  value={profileCompleteness}
                  sx={{ my: 1 }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default AddEditStudent;
